import { Editor } from '@tiptap/core';

export function applyLink(editor: Editor, href: string | null) {
  if (!editor) {
    return;
  }

  const chain = editor.chain().focus().extendMarkRange('link');

  if (!href || href.trim() === '') {
    chain.unsetLink().run();

    return;
  }

  const raw = href.trim();
  const normalized = raw.includes('://') ? raw : `https://${raw}`;

  try {
    chain.setLink({ href: normalized }).run();
  } catch {
    return;
  }
}
